import { message } from 'antd';

// 增加课后练习
const handleAddCourseTask = (
  body: {
    courseCatalogueUuid: string;
    businessConfigUuid: string;
    name?: string;
    icon?: string;
  },
  isTask: boolean,
  callback?: any
) => {
  alo7Api
    .fetch(`${alo7Api.prefix.host}/api/v2/businesses_${alo7Nav.subject}`, {
      method: 'POST',
      body: JSON.stringify({
        ...body,
        task: isTask,
      }),
    })
    .then((res: any) => {
      message.success('添加成功！');
      if (callback) callback();
    })
    .catch((err: any) => {
      message.error('添加失败：' + err.message);
    });
};
// 删除课后练习
const handleDeleteCourseTask = (uuid: string, callback?: any) => {
  alo7Api
    .fetch(
      `${alo7Api.prefix.host}/api/v2/businesses_${alo7Nav.subject}/${uuid}`,
      {
        method: 'DELETE',
      }
    )
    .then((res: any) => {
      message.success('删除成功！');
      if (callback) callback();
    })
    .catch((err: any) => {
      message.error('删除失败：' + err.message);
    });
};
// 编辑课后练习名称
const handleEditCourseTask = (uuid: string, name: string, callback?: any) => {
  alo7Api
    .fetch(
      `${alo7Api.prefix.host}/api/v2/businesses_${alo7Nav.subject}/${uuid}`,
      {
        method: 'PUT',
        body: JSON.stringify({
          name,
        }),
      }
    )
    .then((res: any) => {
      message.success('编辑成功！');
      if (callback) callback();
    })
    .catch((err: any) => {
      message.error('编辑失败：' + err.message);
    });
};

export { handleAddCourseTask, handleDeleteCourseTask, handleEditCourseTask };
